import { render, staticRenderFns } from "./IconLayer.vue?vue&type=template&id=472ded92&scoped=true"
import script from "./IconLayer.vue?vue&type=script&lang=js"
export * from "./IconLayer.vue?vue&type=script&lang=js"
import style0 from "./IconLayer.vue?vue&type=style&index=0&id=472ded92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ded92",
  null
  
)

export default component.exports